module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAM+gAADPoBfoW2/AAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADgSURBVEiJ7dQ9akJBFIbh9/izAcUVaBHtjGvxdrbBO7GxsA8ktYVE9BZuQJciRDSkECWxl7sDryeVzSXpjvjDPNUwB76vmTPgeZ4RAUBV6sPRi0imahmuelwtOu7t3+L6eFyTRL8sS0+youW5c9/p+xxApVBYb/fxQKBmWaqwnIfhD85Zxno3QgCa02l2u4/753hcC9fuIaJ/Fl9inS72gXj3TwAaUZTX5DhBbdcJWJZLxadZECTpQQ5AD4cKZFrGpQCNTRy/Arv0QE6Hx+Goi8qDaa3o58dz+G6a6XlX6xcAj1CHJYSP/gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/resources/icons/CCD-Icon-20.png
// module id = 1239
// module chunks = 0